import InfoTalantbek from './info-talantbek';
export default InfoTalantbek